function Backend(){
    return(
        <>
            <h2>Site backend pages</h2>
        </>
    );
}

export default Backend;